import { render, staticRenderFns } from "./GnbBookmark.vue?vue&type=template&id=44070c75"
import script from "./GnbBookmark.ts?vue&type=script&lang=ts&external"
export * from "./GnbBookmark.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports